/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Import services
  Date: April 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';

export const getImportTypes = (url) => {
  return API.get(`settings/import/import-types`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getJobList = (id) => {
  return API.get(`settings/import/jobs`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const upload = (data) => {
  return API.post(`settings/import/upload`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const pa_upload = (data) => {
  return API.post(`settings/import/pa/upload`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const importJob = (data) => {
  return API.get(`settings/import/${encodeURIComponent(data)}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getJob = (data) => {
  return API.get(`settings/import/jobs/${data}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const getPreSignedUrl = (data) => {
  return API.post(`settings/import/upload/pre-signed-url`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const uploadToS3 = (data) => {
  delete API.defaults.headers['Authorization'];
  return API.put(data.url, data.file);
};

export const previewAgain = (data) => {
  return API.get(`settings/import/preview/${encodeURIComponent(data)}`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};

export const downloadSampleFiles = (data) => {
  return API.get(`settings/import/pa/upload-samples`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};
